module.exports = __webpack_public_path__ + "img/OutsourceHRfunkcije.83c5f037.jpg";